import React from 'react';
// @ts-ignore
import Modal from '../Modal/Modal';
import { useAppContext } from '../../Services/AppContext';
import RemoveConfirmation from './RemoveConfirmation';
import { useTreatmentContext } from '../../Services/TreatmentContext';

interface RemoveConfirmationModalProps {
	opened: boolean;
	onClose: any;
	onConfirm?: () => void;
	confirmationText?: string;
	confirmationTitle?: string;
	customButtons?: () => React.ReactNode | React.ReactNode[];
	showAbort?: boolean;
}

export default function RemoveConfirmationModal(
	props: RemoveConfirmationModalProps,
) {
	const {
		opened,
		onClose,
		onConfirm,
		confirmationText,
		confirmationTitle = 'base.shared.remove',
		customButtons,
		showAbort,
	} = props;
	const { translation } = useAppContext();
	const { isCase } = useTreatmentContext();

	return (
		<div>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header title={confirmationTitle} firstUpper />
				<Modal.Content>
					<RemoveConfirmation
						onConfirm={onConfirm}
						onAbort={onClose}
						confirmationText={confirmationText}
						customButtons={customButtons}
						showAbort={showAbort}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
